import React from 'react';
import { Toaster } from 'sonner';
import { PackageList } from './components/PackageList';
import { ESignPackagePanel } from './components/ESignPackagePanel';
import { usePackages } from './hooks/usePackages';
import { packages } from './data/packages';
export function App() {
  const {
    items,
    selected,
    selectedId,
    setSelectedId,
    busy,
    syncPackage,
    retryPdf
  } = usePackages(packages);
  return <div className="min-h-screen w-full bg-[#b0c4df] font-sans text-ink" data-id="element-0" data-mp="2rk44wzp4wsew">
      <main className="mx-auto max-w-[1600px] space-y-3 p-3 md:p-4" data-id="element-1" data-mp="2mlubatj25zve">
        <div className="grid items-start gap-3 lg:grid-cols-[300px_minmax(0,1fr)]" data-id="element-2" data-mp="2mnnge4e0wc1a">
          <PackageList items={items} selectedId={selectedId} onSelect={setSelectedId} data-id="element-3" data-mp="31c9vq63nh3si" />
          <ESignPackagePanel pkg={selected} busy={busy[selected.id]} onSync={() => syncPackage(selected.id)} onRetryPdf={() => retryPdf(selected.id)} data-id="element-4" data-mp="2wj8dpp85co4p" />
        </div>
      </main>
      <Toaster position="bottom-right" richColors data-id="element-5" data-mp="23t8ea5wf0398" />
    </div>;
}